import { getApiUrl } from 'client/modules/Url';

type FetchMoneyStatusParams = {
  webStationId: string;
  userId: number;
};

export type FetchMoneyStatusResponse = {
  hasAuthenticatedStripe: boolean;
  hasSupportersEnabled: boolean;
  isAllowedToAuthenticateStripe: boolean;
  loginLink: string | null;
  hasSatisfiedStripeAddressRequirements: boolean;
  creatorPaymentCountryCode?: string;
  creatorPaymentCurrencyCode?: string;
};

async function fetchMoneyStatus({
  webStationId,
  userId,
}: FetchMoneyStatusParams): Promise<FetchMoneyStatusResponse> {
  try {
    const url = getApiUrl({
      path: `money/webStationId:${webStationId}/status`,
      queryParameters: {
        userId,
      },
    });
    const response = await fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
    });

    if (response.ok) {
      return response.json();
    }
    throw new Error('Unexpected error');
  } catch (err) {
    throw new Error(err.messages);
  }
}

export { fetchMoneyStatus };
